import SubmitPhotoId from './submit-photo-id'

export default SubmitPhotoId
